import { render, staticRenderFns } from "./TabExame.vue?vue&type=template&id=6527bfcc&scoped=true&"
import script from "./TabExame.vue?vue&type=script&lang=js&"
export * from "./TabExame.vue?vue&type=script&lang=js&"
import style0 from "./TabExame.vue?vue&type=style&index=0&id=6527bfcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6527bfcc",
  null
  
)

export default component.exports